<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('tab.locationLimit')" type="confirm" width="50%" @cancel="cancel" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="data" :rules="rules" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemNo')">
            <vxe-input v-model="data.item.no" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemName')">
            <vxe-input v-model="data.item.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.allocateOrdinal')" prop="ordinal">
            <vxe-number-input v-model="data.ordinal" :min="1" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.limitType')" prop="limitType">
            <vxe-select v-model="data.limitType" :options="limitTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.storageRoom')" prop="storageRoom">
            <vxe-input v-model="data.storageRoom.name" :editable="false" style="width: 100%" @click="onStorageRoomSelect"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.region')">
            <vxe-input v-model="data.region.name" :disabled="data.limitType===2" style="width: 100%" @click="onRegionSelect"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.location')">
            <vxe-input v-model="data.location.no" :disabled="data.limitType===1" style="width: 100%" @click="onLocationSelect"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.caseThreshold')">
            <vxe-number-input v-model="data.caseThreshold" :min="1" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.receivable')" :label-col="wrapperCol" :wrapper-col="labelCol">
            <vxe-switch v-model="data.receivable" size="mini"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.shippable')" :label-col="wrapperCol" :wrapper-col="labelCol">
            <vxe-switch v-model="data.shippable" size="mini"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
    <field-modal ref="regionModal" :no="'LOCATION_REGION'" :show-value="false" :title="$t('business.label.region')" @change="onRegionChange"/>
    <location-modal ref="locationModal" @change="onLocationChange"/>
  </vxe-modal>
</template>
<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { LocationLimit } from '@/api/dto/config/LocationLimit'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { Location } from '@/api/dto/common/Location'
import LocationModal from '@/views/modal/LocationModel.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import FieldModal from '@/views/modal/FieldModal.vue'

export default {
  name: 'LocationLimitEditor',
  components: { FieldModal, StorageRoomModal, LocationModal },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      data: new LocationLimit(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        storageRoom: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        ordinal: [{ required: true, message: this.$t('message.canNotBeEmpty'), min: 0, type: 'number' }],
        limitType: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  props: {
    limitTypes: {
      type: Array,
      default: []
    }
  },
  methods: {
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true, physical: true })
    },
    onStorageRoomChange(value) {
      const storageRoom = new StorageRoom(value[0])
      if (this.data.storageRoom.id !== storageRoom.id) {
        this.data.region = new Dictionary()
        this.data.location = new Location()
      }
      this.data.storageRoom = storageRoom
    },
    onRegionSelect() {
      this.$refs.regionModal.open({ available: true })
    },
    onRegionChange(value) {
      this.data.region = new Dictionary(value[0])
    },
    onLocationSelect() {
      if (this.data.storageRoom.isNew()) {
        this.$message.warning(this.$t('message.pleaseSelect', this.$t('business.label.storageRoom')))
      } else {
        this.$refs.locationModal.open({ 'storageRoom.id': this.data.storageRoom.id })
      }
    },
    onLocationChange(value) {
      this.data.location = new Location(value[0])
    },
    add(item) {
      this.visible = true
      this.data = new LocationLimit()
      this.data.item = item
      this.data.ordinal = 1
      this.data.limitType = 1
      this.data.approved = true
      this.data.receivable = true
      this.data.shippable = true
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('locationLimitFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.data = new LocationLimit(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      if (this.data.limitType === 1) {
        if (this.data.region.isNew()) {
          this.$message.warning(this.$t('business.label.region') + this.$t('message.canNotBeEmpty'))
          return
        }
      } else {
        if (this.data.location.isNew()) {
          this.$message.warning(this.$t('business.label.location') + this.$t('message.canNotBeEmpty'))
          return
        }
      }
      this.loading = true
      const data = this.data.toJSONObject()
      data.warehouse = this.warehouse
      save('locationLimitPersister', data).then(res => {
        if (res.success) {
          this.data = new LocationLimit(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.cancel()
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>